import React, { ReactElement, useState, useEffect } from "react"
import { RouteComponentProps } from "@reach/router"
import { Spinner, Navigation, Filtering, Tile, Section } from "../../components"
import { useGetExperiencesByCategory } from "../../Hooks"
import { getTimeFromMin } from "../../lib"
import { sendPageTrackingEvent } from "../../services"

import styles from "./Experiences.scss"

const ExperiencesPage = ({}: RouteComponentProps) => {
  function renderTiles(children: Experience[]) {
    const sections: ReactElement[] = []
    children.forEach(
      ({ name, price, sessions, pics }: Experience, i: number) => {
        sections.push(
          <Tile
            key={`${name}-${i}`}
            index={i}
            title={name}
            duration={getTimeFromMin(
              sessions.map((s) => s.duration).reduce((curr, acc) => acc + curr)
            )}
            picture={pics[0]}
            price={price}
          />
        )
      }
    )
    return <div id="experiences">{sections}</div>
  }

  const [loading, setLoading] = useState<boolean>(true)
  const [searchedLocation, setSearchedLocation] = useState<{
    lat: string
    lng: string
  }>({})
  const [radius, setRadius] = useState<number>(30)
  const [categories, setCategories] = useState<[string]>([])
  const [selectedCategory, setSelectedCategory] = useState<string>("Tous")

  // const experiences = filterExperiencesByDate(filter, filterIndex, setLoading)
  sendPageTrackingEvent("Experiences")
  const experiences = useGetExperiencesByCategory(
    "experience",
    setLoading,
    selectedCategory,
    radius,
    searchedLocation
  )
  useEffect(() => {
    if (categories.length <= 1) {
      setCategories([
        ...new Set([...experiences.map((exp) => exp.category), "Tous"]),
      ])
      window.scrollTo(0, 0)
    }
  }, [experiences])
  return (
    <>
      <Navigation animated={false} />
      <Section title="LES EXPERIENCES">
        {loading ? (
          <Spinner />
        ) : (
          <div className={styles.center}>
            <Filtering
              categories={categories}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              setSearchedLocation={setSearchedLocation}
            />
            <div>{renderTiles(experiences)}</div>
          </div>
        )}
      </Section>
    </>
  )
}

export default ExperiencesPage
